import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';

/**
 * Componente para selecionar o tipo de destinatário
 */
export const RecipientSelector = ({ value, onChange, error, helperText }) => {
  return (
    <FormControl fullWidth error={error}>
      <InputLabel id="recipient-type-label">Tipo de Destinatário</InputLabel>
      <Select
        labelId="recipient-type-label"
        id="recipient-type"
        value={value || ''}
        onChange={onChange}
        label="Tipo de Destinatário"
      >
        <MenuItem value="STUDENT">Aluno Específico</MenuItem>
        <MenuItem value="RESPONSABLE">Responsável Específico</MenuItem>
        <MenuItem value="CLASSROOM">Turma(s)</MenuItem>
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};


